import { RadiologyBoxOutlineIcon } from './RadiologyBoxOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 75708207-7E52-443D-B1DE-5BA088AED95E
 * name radiology-box-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiology-box-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const XRayBoxOutlineIcon = RadiologyBoxOutlineIcon;
export default XRayBoxOutlineIcon